import { render, staticRenderFns } from "./assistantContactRecord.vue?vue&type=template&id=03230fb0&scoped=true&"
import script from "./assistantContactRecord.vue?vue&type=script&lang=js&"
export * from "./assistantContactRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03230fb0",
  null
  
)

component.options.__file = "assistantContactRecord.vue"
export default component.exports